import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const createQuestionSet = (listeningId, part, data) =>
  apiClient.post(ENDPOINTS.LISTENING.CREATE_QUESTION_SET(listeningId, part), data);

export const updateQuestionSet = (listeningId, part, questionSetId, data) =>
  apiClient.put(ENDPOINTS.LISTENING.UPDATE_QUESTION_SET(listeningId, part, questionSetId), data);

export const deleteQuestionSet = (listeningId, part, questionSetId) =>
  apiClient.delete(ENDPOINTS.LISTENING.DELETE_QUESTION_SET(listeningId, part, questionSetId));

export const getAllQuestionSets = (listeningId, part) =>
  apiClient.get(ENDPOINTS.LISTENING.QUESTION_SETS(listeningId, part));

export const getQuestionSetById = (listeningId, part, questionSetId) =>
  apiClient.get(ENDPOINTS.LISTENING.QUESTION_SET(listeningId, part, questionSetId));
